import { createContext, useContext } from 'react';

/**
 * True inside a Lab entry. Components that would otherwise reach real state from the browser tab (not through
 * props or MemoryProvider), such as the admin mocks, render from fixed data there instead.
 */
export const InLab = createContext(false);
export const useInLab = () => useContext(InLab);
